import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const ContainerStyled = styled.div`
  padding: 2rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 3rem 4rem;
    }
  `}
`;

export const ReleaseNotesWrapStyled = styled.div`
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 2rem 4rem;
    }
  `}
`;

export const MainContainerStyled = styled.section`
  max-width: 1080px;
  min-height: 100vh;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.primary.variant2};
  box-shadow: ${({ theme }) => theme.shadows.variant1};
`;

export const HeroStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.variant3};
`;

export const NotesListStyled = styled.ul`
  list-style: disc;
  margin-left: 1.25rem;
`;

export const CategoryTitleStyled = styled(Typography)`
  margin-top: 1rem;
`;

export const TypographyStyled = styled(Typography)`
  word-break: break-word;
`;

export const VersionStyled = styled(Typography)`
  margin-left: 0.625rem;
  padding: 0.25rem;
  background-color: ${({ theme }) => theme.colors.primary.variant3};
  border-radius: ${({ theme }) => theme.radius.sm};
`;

export const NotesByDateListItemStyled = styled.li`
  margin-bottom: 2rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-bottom: 2rem;
    }
  `}
`;

export const ListItemStyled = styled.li`
  padding: 0.5rem 0.5rem 0.5rem 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.md};
`;
